import i18n from 'i18next';

import SectionHeader from '../../components/SectionHeader/SectionHeader.tsx';
import { LayoutConfiguration } from '../LayoutConfiguration/layout-configuration-factory.ts';

export const createHeaderComponent = (slot: LayoutConfiguration, index:number) => {
  switch (slot.component) {
    case 'SectionHeader': {
      const txt = slot.settings?.text?.toString() || '';
      return <SectionHeader key={`fb-${index}`} text={i18n.t(txt)} />;
    }
    default:
      return <></>;
  }
};
